let scrollPosition = 0;

// Fonction pour détecter si c'est un appareil iOS
const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

// Fonction pour détecter si la largeur de l'écran est inférieure à 992px
export const isScreenSmall = () => {
  return window.innerWidth < 992;
}

export const lockBody = () => {
  const body = document.body;

  body.style.overflow = 'hidden';
  body.style.paddingRight = 'var(--scrollbar-width)';
  body.style.setProperty('--pos-right', 'var(--scrollbar-width)');

  if (isIOS() && isScreenSmall()) {
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = `-${scrollPosition}px`; // Garde la position actuelle
    body.style.left = '0';
    body.style.width = '100%';

    body.style.paddingRight = 'var(--scrollbar-width)';
    body.style.setProperty('--pos-right', 'var(--scrollbar-width)');
  }
};

export const unlockBody = () => {
  const body = document.body;

  body.style.overflow = '';
  body.style.paddingRight = '';
  body.style.setProperty('--pos-right', '0px');

  if (isIOS() && isScreenSmall()) {
    body.style.overflow = '';
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.width = '';

    body.style.paddingRight = '';
    body.style.setProperty('--pos-right', '0px');

    // Restaure la position de défilement sauvegardée
    window.scrollTo(0, scrollPosition);
  }
};